// extracted by mini-css-extract-plugin
export default {"companyContainer":"TN-z","companyImage":"UN-z","container":"VN-z","heading":"WN-z","darkText":"XN-z","smallHeading":"YN-z","darkBackground":"ZN-z","whiteBackground":"_N-z"};